import ApiRequest from "@/helpers/ApiRequest";
import GetHeaders from "@/helpers/GetHeaders";
import { SAVE_FAVORITES } from "@/store/mutation-types";

export default {
  actions: {
    loadFavorites: async ({ commit }) => {
      return ApiRequest.exploreGet("like", GetHeaders.dataHeaders()).then(
        res => {
          commit(SAVE_FAVORITES, { favorites: res.data });
        }
      );
    },
    saveFavorite: async ({ dispatch }, payload) => {
      return ApiRequest.explorePost(
        "like",
        { docs: [payload.webkey] },
        GetHeaders.dataHeaders()
      ).then(() => {
        dispatch("loadFavorites");
      });
    },
    deleteFavorite: async ({ dispatch }, payload) => {
      return ApiRequest.exploreDelete(
        "like/" + payload.webkey,
        GetHeaders.dataHeaders()
      ).then(() => {
        dispatch("loadFavorites");
      });
    }
  },
  getters: {},
  mutations: {
    [SAVE_FAVORITES](state, payload) {
      state.favorites = payload.favorites;
    }
  },
  state: {
    favorites: []
  }
};
